import React from 'react'
import { connect } from 'react-redux'
import CompanyProfile from '../CompanyProfile/CompanyProfile'
import Popup from '../Popup/Popup'
import {
  openProfilesSelector,
  getViewport,
  getExpandedProfile,
} from '../../redux/selector'
import {
  showCompanyProfile,
  hideCompanyProfile,
  expandCompanyProfile,
  collapseCompanyProfile,
} from '../../redux/modules/companies'
import { updateViewport } from '../../redux/modules/map'
import { getDisplayCoords } from '../Map'

const PopupLayer = ({
  openProfiles,
  handleClick,
  handleClose,
  handleExpand,
  handleCollapse,
  expandedProfile,
  viewport,
}) =>
  openProfiles.map(company => {
    const { id, currentAddress } = company
    const { lat, lng } = currentAddress.position
    return (
      <Popup key={`popup-${id}`} latitude={lat} longitude={lng}>
        <CompanyProfile
          company={company}
          expand={expandedProfile === id}
          onClick={handleClick}
          onClose={handleClose}
          onExpand={handleExpand}
          onCollapse={handleCollapse}
        />
      </Popup>
    )
  })

const mapStateToProps = state => ({
  openProfiles: openProfilesSelector(state),
  viewport: getViewport(state), // TODO: (2) Layer gets viewport from parent component (Map), check
  expandedProfile: getExpandedProfile(state),
})

const mapDispatchToProps = (dispatch, { viewport }) => ({
  handleClick: id => dispatch(showCompanyProfile(id)),
  handleClose: id => dispatch(hideCompanyProfile(id)),
  handleCollapse: () => dispatch(collapseCompanyProfile()),
  handleExpand: ({ id, lat, lng }) => {
    const newViewport = { ...viewport, latitude: lat, longitude: lng }
    const { left, top } = getDisplayCoords(newViewport)
    const offsetX = ((lng - left) / 7) * 3
    const offsetY = (top - lat) / 2

    dispatch(
      updateViewport({
        viewport: {
          ...newViewport,
          longitude: lng - offsetX,
          latitude: lat + offsetY,
        },
        transition: true,
      })
    )

    dispatch(expandCompanyProfile(id))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupLayer)
